import type { GlobalLocale } from "@/locales/fr/global";

import { EMonth } from "@/types/common/month.ts";

const globalLocale: GlobalLocale = {
  common: {
    yes: "Yes",
    no: "No",
    filters: {
      hide: "Hide filters",
      display: "Show filters",
    },
  },
  global: {
    postalAddress: "Postal address",
    geolocalizedAddress: "Geolocalized address",
    surface: "Surface",
    all: "All",
    clearAll: "Clear all",
    welcomeName: "Welcome {name} 👋",
    companyName: "Company Name",
    externId: "External ID",
    beforeNumber: "Before {number}",
    refreshResults: "Refresh results",
    optional: "Optional",
    serial: "Serial number",
    hwId: "Hardware Id",
    csId: "CS Id",
    installationDate: "Installation date",
    enabled: "Enabled",
    disabled: "Disabled",
    hello: "Hello",
    site: "Site",
    sites: "Sites",
    details: "Details",
    results: "Results",
    category: "Category",
    noResults: "No results",
    noResultsDesc: "No results found",
    operator: "Operator",
    priority: "Priority",
    description: "Description",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    creationDate: "Creation date",
    dae: "Events",
    filterEventCategories: "Filter event categories",
    password: "Password",
    status: "Status",
    comment: "Comment",
    cancel: "Cancel",
    previous: "Previous",
    next: "Next",
    submit: "Submit",
    modulator: "Modulators",
    modulators: "Modulators",
    device: "Device",
    planning: "Planning MyV",
    devices: "Devices",
    eligibleDevices: "Eligible devices",
    radiators: "Radiators",
    waterHeaters: "Water heaters",
    pac: "HP",
    devicesAlreadyInstalled: "Devices already installed",
    devicesLeftToInstalll: "Remaining devices to install",
    add: "Add",
    mombox: "Mombox",
    momboxs: "Momboxs",
    sensor: "Sensor",
    sensors: "Sensors",
    temperatureSensor: "Temperature Sensor",
    temperatureSensors: "Temperature Sensors",
    ok: "Ok",
    nok: "NOK",
    partnership: "Partnership",
    eligible: "Eligible",
    consent: "Consent",
    subscription: "Subscription",
    deliveryPoint: "MPAN",
    partner: "Partner",
    leftToInstall: "Left to install",
    alreadyInstalled: "Already installed",
    subscriber: "Subscriber",
    subscriberId: "Subscriber Id",
    search: "Search",
    analyze: "Analyze",
    update: "Update",
    upload: "Upload",
    mission: "Mission",
    missions: "Missions",
    operation: "Operation",
    operations: "Operations",
    id: "Id",
    address: "Address",
    subscribedPower: "Subscribed Power",
    firstname: "Firstname",
    lastname: "Lastname",
    fullname: "Fullname",
    email: "Email",
    phone: "Phone",
    psb: "PSB",
    vip: "VIP",
    zipCode: "Post Code",
    city: "City",
    country: "Country",
    pilot: "Pilot",
    pilotCsId: "Pilot CS ID",
    pilotHwId: "Pilot HW ID",
    modCsId: "Modulator CS ID",
    modHwId: "Modulator HW ID",
    modNeuronId: "Modulator Neuron ID",
    modSerialNumber: "Modulator Serial",
    asc: "Ascending",
    desc: "Descending",
    error: "An error occurred, please try again later!",
    formError: "Please check the values entered for errors",
    missingInfo: "Missing information",
    truncatedTitle: "Partial display",
    truncated: "Too much data to display",
    months: {
      [EMonth.JANUARY]: "January",
      [EMonth.FEBRUARY]: "February",
      [EMonth.MARCH]: "Match",
      [EMonth.APRIL]: "April",
      [EMonth.MAY]: "May",
      [EMonth.JUNE]: "June",
      [EMonth.JULY]: "July",
      [EMonth.AUGUST]: "August",
      [EMonth.SEPTEMBER]: "September",
      [EMonth.OCTOBER]: "October",
      [EMonth.NOVEMBER]: "November",
      [EMonth.DECEMBER]: "December",
    },
    offer: "Offer",
    appliances: "Appliances",
    appointments: "Appointments",
  },
};

export default globalLocale;
